const RapidTestComponents = [
    { key: 'temperature', label: 'Temperature', type: 'numeric' },
    { key: 'butterfat_percent', label: 'Butterfat %', type: 'numeric' },
    { key: 'protein_percent', label: 'Protein %', type: 'numeric' },
    { key: 'solids_not_fat_percent', label: 'Solids Not Fat %', type: 'numeric' },
    { key: 'total_solids_percent', label: 'Total Solids %', type: 'numeric' },
    { key: 'titratable_acidity', label: 'Titratable Acidity', type: 'numeric' },
    { key: 'cryo', label: 'Cryo', type: 'numeric' },
    { key: 'ph', label: 'pH', type: 'numeric' },
    { key: 'adv', label: 'ADV', type: 'numeric' },
    { key: 'antibiotics', label: 'Antibiotics', type: 'boolean', trueLabel: 'Positive', falseLabel: 'Not Found' },
    { key: 'solids_weight', label: 'Solids Weight', type: 'numeric' },
    { key: 'dry_matter_basis_percent', label: 'Dry Matter Basis %', type: 'numeric' },
    { key: 'other_solids_percent', label: 'Other Solids %', type: 'numeric' },
    { key: 'butterfat_diluted_percent', label: 'Butterfat - Diluted %', type: 'numeric' },
    { key: 'butterfat_undiluted_percent', label: 'Butterfat - Undiluted %', type: 'numeric' },
    { key: 'protein_diluted_percent', label: 'Protein - Diluted %', type: 'numeric' },
    { key: 'protein_undiluted_percent', label: 'Protein - Undiluted %', type: 'numeric' },
    { key: 'lactose_percent', label: 'Lactose %', type: 'numeric' },
    { key: 'flavor_aroma', label: 'Flavor & Aroma', type: 'boolean', trueLabel: 'Acceptable', falseLabel: 'Unacceptable' },
];

export default RapidTestComponents;
